import { render, staticRenderFns } from "./HabilitarEstudiante.vue?vue&type=template&id=070b9ece&"
import script from "./HabilitarEstudiante.vue?vue&type=script&lang=js&"
export * from "./HabilitarEstudiante.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports